//----------------------------------------
// toggle-section.js
//----------------------------------------

$('.main-section .head .container').on('click', function() {
  var section = $(this).parents('section.main-section');

  if (section.hasClass('active')) {
    section.removeClass('active');
    section[0].focus();
    history.pushState({}, document.title, window.location.pathname + window.location.search);
    if($(window).scrollTop() > section.offset().top){
        $('html, body').animate({ 
            scrollTop: section.offset().top, 
        }, 0);
    }
  } else {
    var href = "#" + section.attr('id');
    section.addClass('active');
    history.pushState({}, '', href);
    checkAnchor();
    
    if($(section).find('.block--drug-options').length > 0){
      const scrollbars = Scrollbar.getAll();

      scrollbars.forEach((scrollbar) => {
        scrollbar.update();
      });
    }
  }
});